<template>
    <div class="" id="exportContent">
        <div class="row">
            <div class="col-md-12">
                <h5>SUMMARY LAPORAN MANAJEMEN {{ showperiodtype.toUpperCase() }} {{ month }} {{ year }}</h5>
            </div>
        </div>

        <div class="row" id="filterControl">
            <div class="col-md-12">
                <el-form  class="mt-2 demo-dynamic" label-position="top" label-width="100px" :inline="true">
                
                    <el-form-item label="">
                        <el-select v-model="year" filterable placeholder="Select Year" size="medium" style="max-width: 100px;">
                            <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                
                    <el-form-item label="">
                        <el-select v-model="month" filterable placeholder="Select Month" size="medium" style="max-width: 120px;">
                            <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="">
                        <el-radio-group v-model="showperiodtype" size="medium" class="ms-0">
                            <el-radio-button label="current">CURRENT</el-radio-button>
                            <el-radio-button label="ytd">YTD</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="">
                        <el-radio-group v-model="category" size="medium" class="ms-0">
                            <el-radio-button v-for="item in options.maincategories" :key="item.value" :label="item.value">{{ item.name }}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="" v-if="category=='FUEL' || options.fuelcategories.some(cat => cat.value === category)">
                        <el-radio-group v-model="category" size="medium" class="ms-0">
                            <el-radio-button v-for="item in options.fuelcategories" :key="item.value" :label="item.value">{{ item.name }}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="" v-if="category=='NON-FUEL' || options.nonfuelcategories.some(cat => cat.value === category)">
                        <el-radio-group v-model="category" size="medium" class="ms-0">
                            <el-radio-button v-for="item in options.nonfuelcategories" :key="item.value" :label="item.value">{{ item.name }}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="" v-if="false">
                        <el-select v-model="category" filterable placeholder="Select Category" size="medium" style="max-width: 250px;">
                            <el-option v-for="item3 in options.categories" :key="item3.value" :label="item3.name" :value="item3.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item v-if="false">
                        <el-button size="medium" :loading="loading.table" @click="applyFilter">Konsol</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="danger" size="medium" @click="printPage()">Save as PDF</el-button>
                    </el-form-item>
                                  
                </el-form>
            </div>
        </div>

        <div class="row">
            <div class="col-md-3 mb-3">
                <LineChartCardView :title="'LABA BERSIH'" :data="chartdata.lababersih" :loadingchart="loading.chart" :key="'laba_bersih'"/>
            </div>
            <div class="col-md-3 mb-3" v-if="category=='CONSOL' || category=='FUEL' || options.fuelcategories.some(cat => cat.value === category)">
                <BarChartCardView :title="(category=='CONSOL') ? 'VOLUME' : 'VOLUME PER PRODUK' " :data="chartdata.volume" :loadingchart="loading.chart" :isstacked="true" :key="'volume'" :label="'Legend'" :legend="'Label'" />
            </div>
            <div class="col-md-3 mb-3">
                <BarChartCardView :title="category=='CONSOL' ? 'PENDAPATAN' : 'PENDAPATAN PER SEGMENT' " :data="chartdata.pendapatan" :loadingchart="loading.chart" :isstacked="true" :key="'sales'" :label="'Legend'" :legend="'Label'" />
            </div>

            <div class="col-md-3 mb-3" v-if="category=='NON-FUEL' || options.nonfuelcategories.some(cat => cat.value === category)">
                <LineChartCardView :title="'GROSS MARGIN'" :data="chartdata.grossmargin" :loadingchart="loading.chart" :key="'gross_margin'"/>
            </div>

            <div class="col-md-3 mb-3">
                <BarChartCardView :title="'BEBAN USAHA/OPERASI'" :data="chartdata.bebanusahaoperasi" :loadingchart="loading.chart" :isstacked="true" :key="'beban_usaha_operasi'" :label="'Legend'" :legend="'Label'" />
            </div>

            <div class="col-md-3 mb-3" v-if="category=='CONSOL'">
                <LineChartCardView :title="'PITSA'" :data="chartdata.pitsa" :loadingchart="loading.chart" :key="'pitsa'"/>
            </div>
            <div class="col-md-3 mb-3" v-if="category=='CONSOL'">
                <LineChartCardView :title="'PENDAPATAN/BEBAN BUNGA'" :data="chartdata.bebanbunga" :loadingchart="loading.chart" :key="'beban_bunga'"/>
            </div>
            <div class="col-md-3 mb-3">
                <LineChartCardView :title="'PENDAPATAN/BEBAN LAIN'" :data="chartdata.bebanlain" :loadingchart="loading.chart" :key="'beban_lain'"/>
            </div>
            <div class="col-md-3 mb-3">
                <LineChartCardView :title="'PAJAK PENGHASILAN'" :data="chartdata.pajakpenghasilan" :loadingchart="loading.chart" :key="'ppn'"/>
            </div>

            <div class="col-md-3 mb-3">
                <LineChartCardView :title="'EBITDA'" :data="chartdata.ebitda" :loadingchart="loading.chart" :key="'ebitda'"/>
            </div>
            <div class="col-md-3 mb-3" v-if="category=='CONSOL'">
                <BarChartCardView v-if="false" :title="'TERITORY LEADERSHIP'" :data="chartdata.teritoryleadership" :loadingchart="loading.chart" :key="'teritory'"/>
                <el-card shadow="hover">
                    <div slot="header" class="px-1">
                        <h6 class="text-center m-0">TERITORY LEADERSHIP</h6>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <table class="table-g" style="width:100%;">
                                <thead>
                                    <tr class="border-bottom">
                                        <th class="py-2">TYPE</th>
                                        <th class="py-2 px-3">REAL 2023</th>
                                        <th class="text-center">RKAP 2024</th>
                                        <th class="text-center">REAL 2024</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in chartdata.teritoryleadership" :key="item.Type">
                                        <td class="py-2 align-top">{{ item.Type }}</td>
                                        <td class="py-2 px-3"> {{ formatNum(item.RealBefore,0) }}</td>
                                        <td class="py-2 px-3">{{ formatNum(item.RkapCurrent,0) }}</td>
                                        <td class="py-2 text-center">{{ formatNum(item.RealCurrent,0) }}</td>
                                    </tr>
                                    <!--
                                    <tr>
                                        <td class="py-2 align-top">COCO</td>
                                        <td class="py-2 px-3">170</td>
                                        <td class="py-2 px-3">175</td>
                                        <td class="py-2 text-center">172</td>
                                    </tr>
                                    <tr>
                                        <td class="py-2 align-top">KSO</td>
                                        <td class="py-2 px-3">12</td>
                                        <td class="py-2 px-3">12</td>
                                        <td class="py-2 text-center">10</td>
                                    </tr>
                                    <tr>
                                        <td class="py-2 align-top">TAC</td>
                                        <td class="py-2 px-3">80</td>
                                        <td class="py-2 px-3">207</td>
                                        <td class="py-2 text-center">122</td>
                                    </tr>
                                    <tr>
                                        <td class="py-2 align-top">SPBG</td>
                                        <td class="py-2 px-3">16</td>
                                        <td class="py-2 px-3">16</td>
                                        <td class="py-2 text-center">16</td>
                                    </tr>
                                    <tr>
                                        <td class="py-2 align-top">SPBUT</td>
                                        <td class="py-2 px-3">25</td>
                                        <td class="py-2 px-3">25</td>
                                        <td class="py-2 text-center">27</td>
                                    </tr>
                                -->
                                    <!--
                                    <tr class="border-top">
                                        <td class="pt-2 fw-bold" colspan="2">Total</td>
                                        <td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
                                    </tr>
                                    -->
                                </tbody>
                            </table>
                            <Loader v-if="loading.chart" />
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="col-md-3 mb-3" v-if="category=='CONSOL'">
                <PieChartCardView :title="'CASH / NON CASH'" :data="chartdata.cashnoncash" :loadingchart="loading.chart" :key="'cash_non_cash'"/>
            </div>
            <div class="col-md-3 mb-3" v-if="category=='CONSOL'">
                <BarChartCardView :title="'ABI'" :data="chartdata.abi" :loadingchart="loading.chart" :isstacked="true" :key="'abi'" :label="'Legend'" :legend="'Label'" />
            </div>

            <div class="col-md-3 mb-3" v-if="category=='NON-FUEL' || options.nonfuelcategories.some(cat => cat.value === category)">
                <LineChartCardView :title="'LOSSES & WASTE'" :data="chartdata.losseswaste" :loadingchart="loading.chart" :key="'losses_waste'"/>
            </div>
        </div>

    </div>
</template>


<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import Finance from '@/components/page/Finance.js'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import { Rainbow, FuelColor, AppColors, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
//import PieChart from '@/components/chart/Pie.js'
import PieChart from '@/components/chart/Doughnut.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

import BarChartCardView from '@/views/pages/Finance/PLUnit/LaporanManajemen/Component/BarChartCardView.vue'
import LineChartCardView from '@/views/pages/Finance/PLUnit/LaporanManajemen/Component/LineChartCardView.vue'
import PieChartCardView from '@/views/pages/Finance/PLUnit/LaporanManajemen/Component/PieChartCardView.vue'
//
export default
{
	extends: KinerjaKeuangan,
	components: { 
        //PieChart,
        //BarChart,
		//ReportResultTable,
        Loader,
        BarChartCardView,
        LineChartCardView,
        PieChartCardView,
	},

	data(){
		return {
            chartdata: {
                lababersih: [],
                volume: [],
                pendapatan: [],
                bebanusahaoperasi: [],
                pitsa: [],
                bebanbunga: [],
                bebanlain: [],
                pajakpenghasilan: [],
                ebitda: [],
                teritoryleadership: [],
                cashnoncash: [],
                abi: [],
                losseswaste: [],
                grossmargin: [],
            },
            titlevolume: 'VOLUME',



            chartproporsikinerjadata:[],
            barchartsmartstylishexperiencedata:[],

            showperiodtype: 'ytd',
            category: 'CONSOL',

            stacked: false,
            loading: {
				table: false,
                tableDetail: false,
				chart: false,
				isSuccess: false,
                isSuccessDetail: false,
			},
            reportdata: [],
            urlRequestParams: '',
            unitId: '',
            station: {
                list: [],
            },

            titlecategory: 'YTD (' + Penanggalan().tahun +')',
            rkapcategory: 'ytd',

            month: (Penanggalan().bulan > 1 ? Penanggalan().bulan-1 : Penanggalan().bulan),
            year: Penanggalan().tahun,

            salesarea: '',
			//month: '', //Penanggalan().bulan,
            //year: Penanggalan().tahun,

            options: {
                salesarea: [
                    { Value:'1', Name:'1' },
                    { Value:'2', Name:'2' },
                    { Value:'3', Name:'3' },
                    { Value:'4', Name:'4' },
                    { Value:'5', Name:'5' },
                ],
                group:[
					{ value: 'monthly', name: 'MONTHLY' },
					{ value: 'ytd', name: 'YTD' },
				],
                months:[
                    //{value:'', name: 'All/Ytd'},
                    {value:1, name: 'Januari'},
                    {value:2, name: 'Februari'},
                    {value:3, name: 'Maret'},
                    {value:4, name: 'April'},
                    {value:5, name: 'Mei'},
                    {value:6, name: 'Juni'},
                    {value:7, name: 'Juli'},
                    {value:8, name: 'Agustus'},
                    {value:9, name: 'September'},
                    {value:10, name: 'Oktober'},
                    {value:11, name: 'November'},
                    {value:12, name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                    {value:'2024', name: '2024'},
                    {value:'2025', name: '2025'},
                ],
                categories: [
                    {value:'consol', name: 'Konsol'},
                    {value:'fuel', name: 'Fuel'},
                    {value:'coco', name: 'COCO'},
                    {value:'kso', name: 'KSO'},
                    {value:'tac', name: 'TAC'},
                    {value:'spbg', name: 'SPBG'},
                    {value:'spbut', name: 'SPBUT'},
                    {value:'pertashop', name: 'Pertashop'},
                    {value:'non_fuel', name: 'Non Fuel'},
                    {value:'convenience', name: 'Convenience Store'},
                    {value:'cafe', name: 'Cafe'},
                    {value:'merchandise', name: 'Merchandise Official'},
                    {value:'private_label', name: 'Private Label'},
                    {value:'bpp', name: 'BPP'},
                    {value:'lpg', name: 'LPG'},
                    {value:'pelumas', name: 'Pelumas'},
                    {value:'nfr', name: 'NFR Tenant & Event'},
                    {value:'ev', name: 'EV'},
                    {value:'modular', name: 'Modular DODO'},
                ],
                maincategories: [
                    {value:'CONSOL', name: 'Konsol'},
                    {value:'FUEL', name: 'Fuel'},
                    {value:'NON-FUEL', name: 'Non Fuel'},
                ],
                fuelcategories: [
                    {value:'COCO', name: 'COCO'},
                    {value:'KSO', name: 'KSO'},
                    {value:'TAC', name: 'TAC'},
                    {value:'SPBG', name: 'SPBG'},
                    {value:'SPBUT', name: 'SPBUT'},
                    {value:'PERTASHOP', name: 'Pertashop'},
                ],
                nonfuelcategories: [
                    {value:'CONVENIENCE-STORE', name: 'Convenience Store'},
                    {value:'CAFE', name: 'Cafe'},
                    {value:'MERCHANDISE-OFFICIAL', name: 'Merchandise Official'},
                    {value:'PRIVATE-LABEL', name: 'Private Label'},
                    {value:'BPP', name: 'BPP'},
                    {value:'LPG', name: 'LPG'},
                    {value:'PELUMAS', name: 'Pelumas'},
                    {value:'NFR', name: 'NFR Tenant & Event'},
                    {value:'EV', name: 'EV'},
                    {value:'MODULAR-DODO', name: 'Modular DODO'},
                ]
            },

            group : 'monthly',

		}
	},
	watch:
	{
		rkapcategory() { 
            //unused, use showperiodtype
            if(this.rkapcategory == 'ytd') {
                this.titlecategory = 'YTD';
            } else {
                this.titlecategory = this.year;
            }

            //this.setTitle();
            this.getData();
        },
		month() { 
            //this.setTitle();
            this.getData() 
        },
		year() { 
            //this.setTitle();
            this.getData() 
        },
		salesarea() { 
            //this.setTitle();
            this.getData();
        },
		showperiodtype() { 
            //this.setTitle();
            this.getData() 
        },
        category() {
            this.getData() 
        }
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
        this.getData() ;
    },
    beforeDestroy() {
        
    },
    methods:{
        async getData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams+='/v1/finance/laporanmanajemen?'

			this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&area='+this.salesarea
            this.urlRequestParams+='&showperiodtype='+this.showperiodtype
            this.urlRequestParams+='&rkapcategory='+this.rkapcategory
            this.urlRequestParams+='&group='+this.category

			this.loading.chart = true;
			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data.data;
                    //this.filteredDataAll = response.data.data
					this.loading.isSuccess = true;

                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata));
                    this.chartdata.lababersih = this.reportdata.laba_bersih;
                    this.chartdata.volume = this.reportdata.volume;
                    this.chartdata.pendapatan = this.reportdata.sales;
                    this.chartdata.bebanusahaoperasi = this.reportdata.beban_usaha;
                    this.chartdata.pitsa = this.reportdata.pitsa;
                    this.chartdata.bebanbunga = this.reportdata.beban_bunga;
                    this.chartdata.bebanlain = this.reportdata.beban_lain;
                    this.chartdata.pajakpenghasilan = this.reportdata.pajak_penghasilan;
                    this.chartdata.ebitda = this.reportdata.ebitda;
                    this.chartdata.teritoryleadership = this.reportdata.teritory_leadrship;
                    this.chartdata.cashnoncash = this.reportdata.cash_non_cash;
                    this.chartdata.abi = this.reportdata.abi;
                    this.chartdata.losseswaste = this.reportdata.losses_waste;
                    this.chartdata.grossmargin = this.reportdata.gross_margin;

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
                    this.loading.chart = false;
					this.loading.table = false;
				})
        },

        setPiecharthData() {
			let item = this.reportdata.data.proporsi_kinerja; //CashPosition;
			//console.log('item pieChartData:' + JSON.stringify(item))
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Label] = AppColors[idx]; //AppColors[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Label, 
                    amount: item[row].Value,
                };

                value.push(main);
                idx++;
            }

            this.chartproporsikinerjadata = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        setBarchartSmartStylishExperience() {
            //console.log('this.maindata: ' + JSON.stringify(this.maindata))
            let label = 'Legend'
            let value = 'Value'
            let legend = 'Label'
            this.barchartsmartstylishexperiencedata = this.processBarChart(this.reportdata.data.smart_stylish_experience, label, '', value, false, legend, "", 1, 2, AppColors, false, false, false, this.stacked);
        },

        calculatePercentage(realisasi, target) {
            const total = parseInt(realisasi) + parseInt(target);
            return (parseInt(realisasi) / total) * 100;
        },

        generateRandomNumber() {
            let min = 500;
            let max = 10000;
            var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
            return randomNumber;
        },

        setTitle() {
            if(this.showperiodtype == 'ytd') {
                this.titlecategory = 'YTD (' + this.options.months[this.month-1].name.toUpperCase() + ' ' + this.year +')';
            } else if (this.showperiodtype == 'year') {
                this.titlecategory = this.year;
            } else if (this.showperiodtype == 'current') {
                this.titlecategory = ' CURRENT (' + this.options.months[this.month-1].name.toUpperCase() + ' ' + this.year +')';
            }
        },

        displayProgress(progress) {
            const progressValue = parseFloat(progress);
            return progressValue < 100 ? this.formatNum(100 - progressValue) + '%' : '';
        },

        applyFilter() {
            this.loadData()
        },

        printPage() {
            window.print();
        }


    },
    computed: {
        selectedMonthLabel() {
            const selectedMonth = this.options.months.find(item => item.value === this.month);
            return selectedMonth ? selectedMonth.name.toUpperCase() : '-';
        }
    },
}
</script>

<style>

.table-pl-lapmen-container {
  /*max-width: 500px; */
  width: 100%;
  margin: auto;
  margin-top: 0rem;
  overflow-x: auto;
  max-height: 450px;
}

.table-pl-lapmen {
  font-family: "Open Sans", sans-serif;
  position: relative;
  border-collapse: initial; /** collapse */
  border-spacing: 0;
  table-layout: auto;
  width: 100%;
  border: none;
  border-radius: 0.5rem;
  /*box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); */
  white-space: nowrap;
}

.table-pl-lapmen thead th {
  background: #edf2f7;  /* $gray-200 */
  padding: 0.45rem 1.0rem;
  vertical-align: middle;
  text-align: center;
  border: 1px solid white;
}

.top-header-1 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 0;
    z-index: 2;
}

.top-header-2 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 70;
    z-index: 2;
}

.table-pl-lapmen thead th:first-child {
    z-index: 4;
}

.table-pl-lapmen th:first-child {
  border-top-left-radius: 0.5rem;
}

.table-pl-lapmen th:last-child {
  border-top-right-radius: 0.5rem;
}


.table-pl-lapmen thead tr {
  color: #2d3748; /* $gray-800 */
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
}

.table-pl-lapmen tbody tr:nth-child(odd) td {
  background: #ffffff; 
}

.table-pl-lapmen tbody tr:nth-child(even) td {
  background: #FAFBFC /*#edf2f7*/; /* $gray-200 */
}

.table-pl-lapmen tbody tr:hover {
  background-color: #e2e8f0 !important; /**e2e8f0 */
}

.table-pl-lapmen tbody tr:hover td {
  background-color: #e2e8f0;
}

.table-pl-lapmen tbody td {
  color: #1a202c; /* $gray-900 */
  text-align: left;
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
  font-size: 0.925rem;
  font-weight: normal;
  border:1px solid #F0F0F0;
}

.table-pl-lapmen tr:last-child td:first-child {
  border-bottom-left-radius: 0.5rem;
}

.table-pl-lapmen tr:last-child td:last-child {
  border-bottom-right-radius: 0.5rem;
}

.table-pl-lapmen tr > th:first-child,
.table-pl-lapmen tr > td:first-child {
  position: sticky;
  left: 0;
}


.bar-container {
    display: flex;
    width: 100%;
    height: 26px;
    background-color: #e0e0e0;
    border-radius: 5px;
    overflow: hidden;
}
.bar {
    height: 100%;
    text-align: center;
    line-height: 26px;
    color: white;
    font-weight: normal;
    font-size:11px;
}
.bar-1 {
    background-color: #67C23A;
    text-align: center;
}
.bar-2 {
    background-color: #909399;
    text-align: center;
}

/* Export PDF */
@media print {
  @page {
    size: landscape;
  }

  /* Hide All Button */
  button {
    display: none;
  }

  /* limit print element*/
  body * {
    visibility: hidden;
  }

  #exportContent, #exportContent * {
    visibility: visible;
  }

  #exportContent {
    position: absolute;
    left: 0;
    top: 0;
  }

  #filterControl {
    visibility: hidden;
    display: none;
  }

  .exportContent {
    visibility: visible;
  }
}
</style>